import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, computed, watch, onMounted, nextTick } from 'vue';
import store from '@/store';
import { useI18n } from 'vue-i18n';
import {
    MultiSelectOption,
    NumberActions,
    NumberFilter,
    NumberGetters,
    SelectOptionsServiceGetCitiesResult,
} from '@/types';
import { FilterIcon } from '@heroicons/vue/solid';
import { toastServiceError } from '@/services/core/notification';
import SelectOptionsService from '@/services/api/SelectOptionsService';


export default /*@__PURE__*/_defineComponent({
  __name: 'NumberListFilters',
  setup(__props, { expose: __expose }) {
  __expose();

const { t } = useI18n();

const filtersOpened = ref(false);
const suppressCityReset = ref(false);

const storeFilter = computed(() => store.getters[NumberGetters.FILTER]);
const defaultFilter = computed(() => store.getters[NumberGetters.DEFAULT_FILTER]);

const filter: Ref<NumberFilter> = ref({
    hasConnectFlow: defaultFilter.value.hasConnectFlow,
    state: null,
    city: null,
});

const hasConnectFlowFilterOptions: Ref<MultiSelectOption[]> = ref([
    {
        label: t('number.filters.hasConnectFlow.options.yes'),
        value: true,
    } as MultiSelectOption,
    {
        label: t('number.filters.hasConnectFlow.options.no'),
        value: false,
    } as MultiSelectOption,
]);

const cities: Ref<SelectOptionsServiceGetCitiesResult[]> = ref([]);
const getCities = async () => {
    try {
        const response = await SelectOptionsService.getCities();
        cities.value = response.data;
    } catch (error) {
        toastServiceError(error);
    }
};

const stateOptions = computed(() =>
    [...new Set(cities.value.map((c) => c.state))].sort().map((state) => ({
        state,
    })),
);
const cityOptions = computed(() =>
    filter.value.state ? cities.value.filter((c) => c.state === filter.value.state) : cities.value,
);

function applyFilters() {
    store.dispatch(NumberActions.SET_FILTER, filter.value);
}

function clearFilters() {
    store.dispatch(NumberActions.CLEAR_FILTER);
    refreshLocalFilter();
}

function refreshLocalFilter() {
    suppressCityReset.value = true;
    filter.value.hasConnectFlow = storeFilter.value.hasConnectFlow;
    filter.value.state = storeFilter.value.state;
    filter.value.city = storeFilter.value.city;
    nextTick(() => {
        suppressCityReset.value = false;
    });
}

watch(
    () => filter.value.state ?? null,
    (nv, ov) => {
        if (nv !== ov && !suppressCityReset.value) {
            filter.value.city = null;
        }
    },
);

watch(filtersOpened, () => {
    if (filtersOpened.value) refreshLocalFilter();
});

onMounted(() => {
    getCities();
});

const __returned__ = { t, filtersOpened, suppressCityReset, storeFilter, defaultFilter, filter, hasConnectFlowFilterOptions, cities, getCities, stateOptions, cityOptions, applyFilters, clearFilters, refreshLocalFilter, get FilterIcon() { return FilterIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})